import React, { useState } from 'react'
import { mainTable } from '../css/Common'
import InputText from '../ReusableComponents/InputText'
import AutoDropDown from '../ReusableComponents/AutoCompleteDropDown'
import DropDown from '../ReusableComponents/DropDown'
import TextArea from '../ReusableComponents/TextArea'

function ComplaintsPopUp({ data }) {
    const [formFields, setFormFields] = useState([])
    const roomTypeDD = {}
    const guestNameData = {}
    const complaintsType = {}
    console.log(data, "data");

    const complaintdate = data.ComplaintsDate ? data.ComplaintsDate.split("T")[0] : "";
    const bookingdate = data.BookingDate ? data.BookingDate.split("T")[0] : "";
    const checkindate = data.CheckinDate ? data.CheckinDate.split("T")[0] : "";

    return (
        <div className="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit sm:max-h-fit">
            <div className={mainTable.grid4}>
                <InputText
                    title="Complaints No"
                    inputType="text"
                    disabled={true}
                    name="complaintsno"
                    content={data.ComplaintsNo}
                // content={"COM-2025-000001"}

                />
                {/* </div>*/}

                <InputText
                    inputType="date"
                    title="Date"
                    name="complaintdate"


                    content={complaintdate}
                    placeholder="Enter Date"
                    disabled='true'
                    // tabIndex="9"
                    isRequired={true}

                    classStar="text-red-500"
                />

                <InputText
                    inputType="date"
                    title="Checkin Date"
                    name="checkindate"


                    content={checkindate}
                    placeholder="Enter Date"
                    disabled={true}
                    // tabIndex="9"
                    isRequired={true}

                    classStar="text-red-500"
                />

                <AutoDropDown
                    name="roomtype"
                    title="Room Type"
                    type="select-one"

                    options={[]}
                    selectedOption={{ value: data.MstRoomTypeId, label: data.RoomType }}
                    placeholder="Select"
                    Class="custom-class"


                    disabled='true'
                />





                <AutoDropDown
                    name="room"
                    title="Room"
                    type="select-one"
                    selectedOption={{ value: data.MstRoomId, label: data.RoomName }}
                    options={[]} // row-specific filtered list
                    placeholder="Select"
                    Class="custom-class"
                    disabled='true'

                />


                <InputText
                    title="Booking No"
                    inputType="text"
                    disabled={true}
                    content={data.BookingNo}
                    name="bookingno"
                // content={formFields.bookingno}

                />
                <InputText
                    title="Booked Person"
                    inputType="text"
                    disabled={true}
                    content={data.BookedPerson}
                    name="bookedperson"
                // content={formFields.bookingno}

                />

                <InputText
                    inputType="date"
                    title="Booking Date"
                    name="bookingdate"


                    content={bookingdate}
                    placeholder="Enter Date"
                    disabled={true}
                    // tabIndex="9"
                    isRequired={true}

                    classStar="text-red-500"
                />


                <DropDown
                    name="guestname"
                    title="Guest Name"
                    type={"select-one"}
                    options={[{ value: data.GuestName, label: data.GuestName }]}

                    selectedOption={data.GuestName}

                    placeholder="Select Guest Name"
                    // tabIndex="12"
                    isRequired={true}
                    disabled='true'

                />





                <DropDown
                    name="complaints"
                    title="Complaints"
                    type={"select-one"}
                    options={[{ value: data.ComplaintsType, label: data.ComplaintsType }]}

                    selectedOption={data.ComplaintsType}
                    disabled='true'

                    placeholder="Select Complaints Type"
                    // tabIndex="12"
                    isRequired={true}

                />
            </div>
            <div className="mt-4">

                <TextArea
                    inputType="text"
                    title="Description"
                    name="description"
                    rows="4"
                    maxlength={500}
                    content={data.Description}
                    placeholder="Enter Description"
                    disabled='true'

                />
            </div>
        </div>
    )
}

export default ComplaintsPopUp
